import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AfastamentoService } from '../../core/services/afastamento.service';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { EtapasBeneficioComponent } from '../../shared/components/etapas-beneficio/etapas-beneficio.component';
import { SessionService } from '../../core/services/session.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

// Formato de data brasileiro
export const BR_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-afastamento',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    EtapasBeneficioComponent,
    MatSnackBarModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: BR_DATE_FORMATS }
  ],
  templateUrl: './afastamento.component.html',
  styleUrls: ['./afastamento.component.scss']
})
export class AfastamentoComponent implements OnInit {
  afastamentoCadastrado: any = null;
  form!: FormGroup;
  beneficiario: any= '';
  /** Envio em andamento: desabilita o Enviar para o clique duplo não repetir o POST. */
  enviando = false;
  constructor(
    private fb: FormBuilder,
    private afastamentoService: AfastamentoService,
    private sessionService: SessionService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      dataAfastamento: [null],
      dataDO: [null],
      paginaDO: [''],
      observacao: ['']
    });
    this.beneficiario = this.sessionService.beneficiario

    this.carregarSituacao();
  }

  /** Carrega o card "Dados do Afastamento Cadastrado" com a situação atual na SEPLAG. */
  carregarSituacao(): void {
    this.afastamentoService.verificarAfastamento(
    this.sessionService.beneficiario.matricula,
    this.sessionService.beneficiario.orgao.id
      ).subscribe({
        next: (res) => {
          this.afastamentoCadastrado = res;
        },
        error: (err) => {
          console.error('Erro ao verificar afastamento', err);
        }
      });
  }

  // Método para processar digitação manual de data
  onDateInput(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove caracteres não numéricos exceto /
    value = value.replace(/[^\d/]/g, '');

    // Auto-adiciona as barras
    if (value.length === 2 && !value.includes('/')) {
      value = value + '/';
    } else if (value.length === 5 && value.split('/').length === 2) {
      value = value + '/';
    }

    // Limita a 10 caracteres (dd/mm/aaaa)
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    input.value = value;

    // Se a data estiver completa (dd/mm/aaaa), converte para Date
    if (value.length === 10) {
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Mês é 0-indexed
        const year = parseInt(parts[2], 10);

        // Valida se é uma data válida
        if (day >= 1 && day <= 31 && month >= 0 && month <= 11 && year >= 1900 && year <= 2100) {
          const date = new Date(year, month, day);
          // Verifica se a data criada é válida
          if (date.getDate() === day && date.getMonth() === month && date.getFullYear() === year) {
            this.form.get(controlName)?.setValue(date);
          }
        }
      }
    }
  }

  // Formata a data para yyyy-mm-dd
  private formatDateToISO(date: Date | string | null): string {
    if (!date) return '';

    if (date instanceof Date) {
      return date.toISOString().split('T')[0];
    }

    // Se for string no formato dd/mm/yyyy
    if (typeof date === 'string' && date.includes('/')) {
      const parts = date.split('/');
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    return '';
  }

  enviar(): void {
    // Clique duplo antes de o botão ficar desabilitado não pode repetir o POST.
    if (this.enviando) return;
    const formData = this.form.value;

    const dataAfastamento = this.formatDateToISO(formData.dataAfastamento);
    const dataDO = this.formatDateToISO(formData.dataDO);

    if (!dataAfastamento) {
      this.snackBar.open('Data de Afastamento é obrigatória', 'Fechar', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
      });
      return;
    }

    const payload = {
      dataAfastamento: dataAfastamento,
      dataDO: dataDO,
      paginaDO: formData.paginaDO,
      observacao: formData.observacao,
      matricula: this.sessionService.beneficiario.matricula,
      idOrgao: this.sessionService.beneficiario.orgao.id
    };

    this.enviando = true;
    this.afastamentoService.enviarAfastamento(payload).subscribe({
      next: () => {
        this.enviando = false;
        this.snackBar.open('Afastamento enviado com sucesso ✅', 'Fechar', {
        duration: 4000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-success']
      });
      this.form.reset();
      // O card mostra o que a SEPLAG registrou, sem precisar recarregar a tela.
      this.carregarSituacao();
      },
      error: (err) => {
        this.enviando = false;
        console.error('Erro ao enviar', err);
        this.snackBar.open(mensagemDoErro(err), 'Fechar', {
        duration: 8000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-error']
      });
      // A SEPLAG pode ter gravado mesmo com erro na resposta: o card mostra a situação real.
      this.carregarSituacao();
      }
    });
  }
}

/** Motivo devolvido pelo militar-back ("message" ou "mensagem"; "detail" no formato ProblemDetail). */
function mensagemDoErro(err: any): string {
  const corpo = err?.error;
  const texto = corpo?.message ?? corpo?.mensagem ?? corpo?.detail;
  return typeof texto === 'string' && texto.trim() ? texto.trim() : 'Erro ao enviar afastamento';
}
